var map = {
	"./AddList.svg": 744,
	"./AutoOff.svg": 745,
	"./Delay.svg": 746,
	"./Facebook.svg": 747,
	"./Gia02_icon.svg": 748,
	"./ImgEmpty.png": 2054,
	"./ImgInfo.png": 2055,
	"./Instagram.svg": 749,
	"./LINE.svg": 750,
	"./PDF.svg": 751,
	"./Telegram.svg": 752,
	"./Twitter.svg": 753,
	"./V.svg": 754,
	"./WalletAdd.svg": 755,
	"./XBackGreen.svg": 198,
	"./XbackIcont.svg": 756,
	"./XbackIcontWhite.svg": 757,
	"./Youtube.svg": 758,
	"./accountCompany.svg": 759,
	"./accountIcon.svg": 760,
	"./accountWallet.svg": 761,
	"./active-green.svg": 762,
	"./active-white.svg": 763,
	"./add-account.svg": 764,
	"./add-green-pdf.svg": 765,
	"./add-personal.svg": 766,
	"./add.svg": 247,
	"./addFilePDF.svg": 371,
	"./addGray.svg": 248,
	"./addListGray.svg": 767,
	"./adminAdd.svg": 768,
	"./adminSetting.svg": 769,
	"./arrowLeftMobilePreview.svg": 770,
	"./arrowLeftWhite.svg": 372,
	"./arrowRight.svg": 199,
	"./avatarHeader.png": 2056,
	"./back.svg": 771,
	"./bank-card.svg": 249,
	"./building.svg": 373,
	"./buildingIcon.svg": 250,
	"./burnIcon.svg": 251,
	"./burnIconGray.svg": 374,
	"./camera-green.svg": 375,
	"./checkGreen.svg": 772,
	"./checkRed.svg": 773,
	"./checkedIcon.svg": 774,
	"./chooseSetting.svg": 775,
	"./circleStatus0.svg": 776,
	"./circleStatus1.svg": 777,
	"./circleStatus2.svg": 778,
	"./circleStatus3.svg": 779,
	"./circleStatus4.svg": 780,
	"./circleSuccess.svg": 252,
	"./clearIconActive.svg": 781,
	"./clockIcon.svg": 376,
	"./close-black.svg": 782,
	"./close-red.svg": 783,
	"./close-text-white.svg": 784,
	"./close-white.svg": 166,
	"./closeGreen.svg": 147,
	"./closeIcon.svg": 200,
	"./closeTokenModal.svg": 785,
	"./closeTokenModalW.svg": 786,
	"./company.svg": 787,
	"./completed.svg": 788,
	"./csv.svg": 253,
	"./date-icon-white.svg": 789,
	"./date-icon.svg": 790,
	"./default-img.svg": 791,
	"./delete-white.svg": 792,
	"./delete.svg": 377,
	"./deleteDraftData.svg": 793,
	"./deletePersonal.svg": 794,
	"./deleteSuccess.svg": 795,
	"./document.svg": 796,
	"./documentPay.svg": 254,
	"./documentPayActive.svg": 255,
	"./earthIcon.svg": 201,
	"./earthWifi.svg": 378,
	"./editIcon.svg": 797,
	"./exclamationIcon.svg": 798,
	"./file1.svg": 799,
	"./fileInput.svg": 800,
	"./folder-blue.svg": 202,
	"./folder.svg": 801,
	"./gift.svg": 802,
	"./grayStatus.svg": 803,
	"./greenStatus.svg": 804,
	"./groupMail.svg": 805,
	"./home.svg": 806,
	"./iconAdd.svg": 807,
	"./iconAddDocument.svg": 808,
	"./iconAddList.svg": 809,
	"./iconAddMail.svg": 810,
	"./iconAddNet.svg": 811,
	"./iconAddNote.svg": 812,
	"./iconAddTXT.svg": 813,
	"./iconAddTag.svg": 814,
	"./iconAddToken.svg": 815,
	"./iconAddWallet.svg": 816,
	"./iconArrowRight.svg": 817,
	"./iconBin.svg": 818,
	"./iconBinWhite.svg": 819,
	"./iconBurn.svg": 820,
	"./iconBurnModal.svg": 821,
	"./iconBurnRed.svg": 379,
	"./iconBurnWhite.svg": 822,
	"./iconButtonToken.svg": 823,
	"./iconButtonTokenList.svg": 824,
	"./iconCalendar.svg": 825,
	"./iconCalendarGrey.svg": 826,
	"./iconCamera.svg": 380,
	"./iconCameraGrey.svg": 381,
	"./iconCheck.svg": 827,
	"./iconCheckActive.svg": 256,
	"./iconCheckPay.svg": 257,
	"./iconCheckSuccess.svg": 828,
	"./iconCheckWhite.svg": 829,
	"./iconClock.svg": 830,
	"./iconClockActive.svg": 831,
	"./iconClose.svg": 382,
	"./iconCloseModal.svg": 258,
	"./iconCloseWhite.svg": 832,
	"./iconCloseWhiteDisable.svg": 833,
	"./iconCommunity.svg": 834,
	"./iconCreateLock.svg": 835,
	"./iconCreateLock2.svg": 836,
	"./iconCreateLockDisabled.svg": 837,
	"./iconDanger.svg": 203,
	"./iconDate.svg": 838,
	"./iconDeleteBin.svg": 259,
	"./iconDeleteBinActive.svg": 260,
	"./iconDeleteDisable.svg": 839,
	"./iconDeleteGray.svg": 840,
	"./iconDeleteRed.svg": 841,
	"./iconDeleted.svg": 383,
	"./iconDeletedActive.svg": 384,
	"./iconDocumentEmpty.svg": 842,
	"./iconDown.svg": 125,
	"./iconDownBlack.svg": 261,
	"./iconDownBlue.svg": 843,
	"./iconDownDisabled.svg": 94,
	"./iconDownload.svg": 844,
	"./iconDownloadGray.svg": 845,
	"./iconDownloadGrey.svg": 846,
	"./iconDropdown.svg": 77,
	"./iconEdit.svg": 385,
	"./iconEditAvatar.svg": 847,
	"./iconEditAvatarGreen.svg": 848,
	"./iconEditModal.svg": 849,
	"./iconExit.svg": 850,
	"./iconExportCSV.svg": 851,
	"./iconEyes.svg": 852,
	"./iconFinancial.svg": 853,
	"./iconFix.svg": 854,
	"./iconFly.svg": 855,
	"./iconHeaderWhiteList.svg": 856,
	"./iconI.svg": 857,
	"./iconImgEmp.svg": 858,
	"./iconLanguage.svg": 859,
	"./iconLanguageModal.svg": 386,
	"./iconLeft.svg": 126,
	"./iconList.svg": 860,
	"./iconListToken.svg": 861,
	"./iconListToken1.svg": 862,
	"./iconListToken2.svg": 863,
	"./iconListToken3.svg": 864,
	"./iconListToken4.svg": 865,
	"./iconListToken5.svg": 866,
	"./iconListToken6.svg": 867,
	"./iconListToken7.svg": 868,
	"./iconLock.svg": 869,
	"./iconLock2FA.svg": 870,
	"./iconLockActive.svg": 871,
	"./iconLogout.svg": 872,
	"./iconMail.svg": 873,
	"./iconMedia.svg": 874,
	"./iconNotAllow.svg": 875,
	"./iconNote.svg": 876,
	"./iconNoteDelete.svg": 877,
	"./iconNoteGreen.svg": 878,
	"./iconNoteLink.svg": 879,
	"./iconNoteLock.svg": 880,
	"./iconPDF.svg": 387,
	"./iconPDFModal.svg": 881,
	"./iconPdfButton.svg": 882,
	"./iconPenalty.svg": 883,
	"./iconProcess.svg": 884,
	"./iconRSX.svg": 885,
	"./iconRecycleBin.svg": 886,
	"./iconRight.svg": 887,
	"./iconSearch.svg": 388,
	"./iconSetting.svg": 888,
	"./iconSetting2.svg": 204,
	"./iconSetting3.svg": 889,
	"./iconSettingWhite.svg": 890,
	"./iconShare.svg": 106,
	"./iconSubnet.svg": 891,
	"./iconTXT.svg": 262,
	"./iconTag.svg": 892,
	"./iconTagLink.svg": 893,
	"./iconThreeDot.svg": 894,
	"./iconTime.svg": 389,
	"./iconTimeBlue.svg": 895,
	"./iconTimeSecond.svg": 896,
	"./iconToBin.svg": 897,
	"./iconToBinActive.svg": 898,
	"./iconTop.svg": 148,
	"./iconUser.svg": 899,
	"./iconView.svg": 263,
	"./iconWallet.svg": 205,
	"./iconWarning.svg": 900,
	"./iconWifi.svg": 901,
	"./iconWifiActive.svg": 902,
	"./iconWifiDisabled.svg": 903,
	"./iconWorld.svg": 390,
	"./iconX-White.svg": 904,
	"./iconX.svg": 905,
	"./iconXCircle.svg": 906,
	"./iconZic.svg": 907,
	"./img.jpg": 2057,
	"./imgAmerica.png": 2058,
	"./imgChina.png": 2059,
	"./imgJapan.png": 2060,
	"./imgTokenTopNews.svg": 908,
	"./info.svg": 909,
	"./inputIcon.svg": 910,
	"./iplus.svg": 911,
	"./kiteGray.svg": 912,
	"./kiteWhite.svg": 391,
	"./listPay.svg": 264,
	"./listPayActive.svg": 265,
	"./loading-black.svg": 392,
	"./loading-green.svg": 913,
	"./loading-white.svg": 914,
	"./lock.svg": 915,
	"./logout-gray.svg": 370,
	"./logout.svg": 393,
	"./logoutGreen.svg": 916,
	"./logoutModal.svg": 917,
	"./mail.png": 2061,
	"./mail.svg": 918,
	"./mailGray.svg": 919,
	"./mailInput.svg": 920,
	"./mail_icon.png": 2062,
	"./mobileBattery.svg": 394,
	"./mobileSignal.svg": 395,
	"./newDocument.svg": 921,
	"./note.svg": 922,
	"./pass.png": 2063,
	"./pass_icon.png": 2064,
	"./payConfirm.svg": 266,
	"./payConfirmActive.svg": 267,
	"./paymed.svg": 268,
	"./paymedActive.svg": 269,
	"./payment-app.svg": 923,
	"./payment.svg": 924,
	"./pdf-download.svg": 925,
	"./pen-icon.svg": 926,
	"./person.svg": 927,
	"./personal.svg": 928,
	"./phone.png": 2065,
	"./phone.svg": 929,
	"./plus.svg": 930,
	"./point.svg": 931,
	"./pointingRight.svg": 270,
	"./previewMobile.svg": 932,
	"./purpleStatus.svg": 933,
	"./redStatus.svg": 934,
	"./registrationEmail.svg": 935,
	"./save.svg": 936,
	"./saveClipboard.svg": 937,
	"./saveGray.svg": 938,
	"./select.svg": 939,
	"./send.svg": 940,
	"./sendBlue.svg": 941,
	"./sendBlueFail.svg": 396,
	"./sendGray.svg": 397,
	"./sendHome.svg": 398,
	"./setting.svg": 399,
	"./settingAdmin.svg": 942,
	"./settingHeader.svg": 943,
	"./settingModal.svg": 944,
	"./shop.svg": 945,
	"./stop.svg": 400,
	"./submit.svg": 946,
	"./success-red.svg": 947,
	"./successBlack.svg": 948,
	"./successGreen.svg": 401,
	"./symbolLevias.svg": 949,
	"./testMail.svg": 950,
	"./testSMS.svg": 951,
	"./text-white.svg": 952,
	"./textSetting.svg": 953,
	"./token_3.svg": 954,
	"./trash.svg": 955,
	"./twoFactorAuthentication.svg": 402,
	"./user.svg": 403,
	"./v-grey.svg": 404,
	"./violetStatus.svg": 956,
	"./warning.svg": 271,
	"./warningIcon.svg": 957,
	"./wifiIcon.svg": 958,
	"./wifiIconGray.svg": 959,
	"./wifiWarning.svg": 405,
	"./x-card-red.svg": 960,
	"./x-phone-red.svg": 961,
	"./yellowStatus.svg": 406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;